import React, { Component } from 'react';

class AVRetail extends Component {
  render() {
    return (
      <div className='col-12 section-space--top--30'>
        <div className='service-grid-item service-grid-item--style2'>
          {/* <div className='service-grid-item__image'> ## image above box
            <div className='service-grid-item__image-wrapper'>
              <img src={`/assets/img/service/serviceShort.jpg`} className='img-fluid' alt='Service Grid' />
            </div>
          </div> */}
          <div name='Retail and Restaurants' className='service-grid-item__content'>
            <h3 className='title'>
              <img width={50} alt={'icon'} style={{ paddingRight: '10px' }} src='/assets/img/icons/retailandrestaurant.png' />
              Retail and Restaurants
            </h3>
            <p className='subtitle'>
              AV systems are a crucial part of the advertising and customer experience aspects of your retail or restaurant business. SL is a skilled provider of 
              digital signage systems (great for advertising specials, menus, deals and more), displays, and distributed sound systems. 
            </p>
            <a
              href="mailto:avsales@sltechnology.net"
              target='BLANK'
              className='ht-btn--default ht-btn--default--dark-hovers'
            >
              CONTACT US
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default AVRetail;
